<template>
  <div class="leco-content">
    <div class="page-title">トレーニング別の人数集計</div>
    <div v-show="mainLoading" class="loader">loading...</div>
    <transition>
      <div v-show="!mainLoading" class="content-wrapper">
        <div class="top-message-wrapper">
          <div class="table-hanrei hanrei-area float-left">
            <span class="hanrei-label">凡例</span>
            絶対参加者数：なんとしてでも参加したいと回答した人数、受講希望者数：都合があえば参加すると回答した人数
          </div>
        </div>
        <div class="clearfix"></div>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          max-height="82vh"
          :fixed-header="true"
          :search-options="{
            enabled: true
          }"
          :sort-options="{
            enabled: true,
            initialSortBy: {
              field: 'total_strong_hope_for_participation',
              type: 'desc'
            }
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'training_name'">
              <router-link
                :to="{
                  name: 'wish-list-detail',
                  params: { id: props.row.id }
                }"
                >{{ props.row.training_name }}</router-link
              >
            </span>
            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import jQuery from "jquery";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import Vue from "vue";
import { API_BASE_URL } from "@/common/config";
Vue.use(VueGoodTablePlugin);

global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require("jquery");

export default {
  name: "wish-list",

  data() {
    return {
      columns: [
        {
          label: "トレーニング名",
          field: "training_name"
        },
        {
          label: "絶対参加者数",
          field: "total_strong_hope_for_participation",
          type: "number"
        },
        {
          label: "受講希望者数",
          field: "total_weak_hope_for_participation",
          type: "number"
        },
        {
          label: "講師数",
          field: "total_capable_for_lecturer",
          type: "number"
        }
      ],
      rows: [],
      mainLoading: false,
      logger: this.$store.state.logger
    };
  },
  computed: {
    filteredUsers: function () {
      var users = [];

      for (var i in this.users) {
        var user = this.users[i];

        if (
          user.name.indexOf(this.keyword) !== -1 ||
          user.email.indexOf(this.keyword) !== -1
        ) {
          users.push(user);
        }
      }

      return users;
    },
    ...mapGetters(["isAuthenticated", "currentUser"])
  },
  created() {
    // 画面スクロールをトップにする
    this.instantScrollTop();

    this.mainLoading = true;
    //トレーニング別希望状況一覧を取得
    this.logger.info("トレーニング別希望状況一覧を取得");
    let api_url = API_BASE_URL + "trainings/wishlist";
    axios
      .get(api_url, {
        headers: {
          Authorization: this.$store.getters.currentUser.idToken.jwtToken
        }
      })
      .then((response) => {
        //statusCode==200以外は全部500のエラー画面に飛ばす
        if ("statusCode" in response.data) {
          if (response.data.statusCode == 200) {
            this.rows = response.data.body;
            this.logger.info("トレーニング別希望状況一覧の読み込み終了。");
            this.logger.debug(JSON.stringify(response.data));
          } else {
            this.$router.push("/system-error500");
          }
        } else {
          this.$router.push("/system-error500");
        }
        this.mainLoading = false;
      })
      .catch((error) => {
        this.mainLoading = false;
        this.logger.error("トレーニング別希望状況一覧の読み込みに失敗");
        this.logger.error(JSON.stringify(error));
        this.$router.push("/system-error500");
      });
  }
};
</script>

<style scoped>
.vgt-table > tbody > tr > td > span > a {
  color: var(--leco-link-color);
}

.top-message-wrapper {
  /* 凡例を下寄せにするために必要 */
  height: 48px;
  position: relative;
}

.table-hanrei {
  /* 凡例を下寄せ */
  position: absolute;
  bottom: 8px;
}

.create-training-master-button {
  margin-bottom: 8px;
}

@media screen and (max-width: 600px) {
  .top-message-wrapper {
    /* モバイル時は余白調整を無効にする */
    position: initial;
  }

  .table-hanrei {
    font-size: 75%;
  }

  .content-wrapper {
    margin-right: 10px;
    margin-left: 10px;
  }
}

/* loadingアイコン用CSS */
.loader {
  font-size: 10px;
  margin: 50px auto;
  text-indent: -9999em;
  width: 5em;
  height: 5em;
  border-radius: 50%;
  background: #000000;
  background: -moz-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -webkit-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: -o-linear-gradient(left, #000000 10%, rgba(255, 255, 255, 0) 42%);
  background: -ms-linear-gradient(
    left,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  background: linear-gradient(
    to right,
    #000000 10%,
    rgba(255, 255, 255, 0) 42%
  );
  position: relative;
  -webkit-animation: load3 1.4s infinite linear;
  animation: load3 1.4s infinite linear;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.loader:before {
  width: 50%;
  height: 50%;
  background: #000000;
  border-radius: 100% 0 0 0;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
}
.loader:after {
  background: #ffffff;
  width: 75%;
  height: 75%;
  border-radius: 50%;
  content: "";
  margin: auto;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

@-webkit-keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load3 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
